import styled from 'styled-components';

import { H4 } from '~/components';
import { breakpoints, colors } from '~/styles';

const { primary } = colors;

const View = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 3.2rem;
  justify-content: space-between;

  ${H4} {
    color: ${primary._000};
    display: flex;
    align-items: center;

    svg {
      top: 0.2rem;
      cursor: pointer;
      position: relative;
      margin-right: 2.4rem;
    }
  }

  @media screen and (max-width: ${breakpoints.md}) {
    flex-direction: column;
  }
`;

export default View;
